<template>
  <div>
    <div class="section has-text-centered">
        <p class="title is-1">{{ this.allProducts[this.parametros.idProduct-1].name }}</p>
        <p class="subtitle is-2">${{ this.allProducts[this.parametros.idProduct-1].price }}</p>
    </div>
    <div class="section">
        <div class="columns">
            <div class="column is-5">
                <b-carousel>
                    <b-carousel-item v-for="(carousel, i) in carousels" :key="i">
                        <section :class="`hero is-medium is-${carousel.color}`">
                            <div class="hero-body has-text-centered">
                                <p class="title is-1">{{carousel.text}}</p>
                            </div>
                        </section>
                    </b-carousel-item>
                </b-carousel>
            </div>
            <div class="column">
                <p>{{ this.allProducts[this.parametros.idProduct-1].description }}</p>
                <div class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <b-numberinput></b-numberinput>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <b-button class="is-success is-medium">
                                <b-icon pack="fas" icon="cart-plus"></b-icon>&#9;Añadir al carrito
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr>
    

    <!-- <p>{{ parametros.idProduct }}</p> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
    name: 'ProductPage',
    data() {
        return {
            no_data: false,
            parametros: {},
            product: {},
            carousels: [
                { text: 'Slide 1', color: 'primary' },
                { text: 'Slide 2', color: 'info' },
                { text: 'Slide 3', color: 'success' },
                { text: 'Slide 4', color: 'warning' },
                { text: 'Slide 5', color: 'danger' }
            ]
        }
    },
    created() {
        this.parametros = this.$route.params
        this.fetchProducts()
    },
    computed: mapGetters(["allProducts"]),
    methods: {
        ...mapActions(["fetchProducts"]),
    },
    mounted() {
        /* this.$axios.get(this.$URL + "products/" + this.parametros.idProduct)
        .then(response => {
            this.product = response.data.data.product
            //console.log(response.data.data.product.name)
        })
        .catch(err => {
            this.no_data = true

            this.$router.push({ name: '404' })
        }) */
    }
}
</script>

<style lang="css" scoped>
    .fix {
        margin-right: 4rem;
    }
</style>